import React from "react";
import extend from "lodash/extend";
import Radium from "radium";
import pick from "lodash/pickBy";
import identity from "lodash/identity";
import Helmet from "react-helmet";
import moment from "moment-timezone";

import * as util from "../util";
import InjectedTenantHTML from "./partials/injected-tenant-html.jsx";
import ModeSwitcher from "./partials/mode-switcher.jsx";
import MarqueeList from "./partials/marquee/marquee-list.jsx";

import connectToStores from "alt-utils/lib/connectToStores";
import EventStore from "../stores/EventStore";
import EventActions from "../actions/EventActions";
import PassActions from "../actions/PassActions";
import FilmStore from "../stores/FilmStore";
import PassStore from "../stores/PassStore";
import TicketStore from "../stores/TicketStore";

@connectToStores
class Marquee extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      date: null
    };

    this.getStyles = this.getStyles.bind(this);
    this.onChangeDate = this.onChangeDate.bind(this);
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object.isRequired,
      tenant: React.PropTypes.object,
      isLarge: React.PropTypes.bool,
      isEmbed: React.PropTypes.bool
    };
  }

  static getStores() {
    return [EventStore, FilmStore, PassStore, TicketStore];
  }

  static getPropsFromStores() {
    let store = EventStore.getState();
    store.films = FilmStore.getState().films;
    store.hasUpdatedFilms = FilmStore.getState().hasUpdatedFilms;
    return store;
  }

  onChangeDate(date) {
    this.context.router.push({
      pathname: `/schedule`,
      query: { date },
      state: { ignoreScrollBehavior: true }
    });

    const current = moment(
      date,
      "YYYY-MM-DD"
    ).startOf("day");

    if (
      !Object.keys(this.props.marquee.showsByDay).some(k => current.isSame(k))
    ) {
      EventActions.fetchMarquee.defer({ date: date });
    }
  }

  onSelectFilm(film) {
    this.context.router.push({
      pathname: `/films/${film}`,
      state: { fromSchedule: true }
    });
  }

  componentWillMount() {
    EventActions.fetchMarquee.defer({ date: this.props.location.query.date });
    this.componentWillReceiveProps(this.props);
  }

  componentWillReceiveProps(newProps) {
    if (this.context.router.isActive(`/schedule`, /* indexOmly */ true)) {
      // Only update shown date on index route -- so we don't lose the current dateview
      // when opening a tickets modal.
      this.setState({ date: newProps.location.query.date });
    }
  }

  getStyles() {
    return {
      injectStyle: {
        marginTop: 10,
        fontSize: 16
      },
      smallInjectStyle: {
        paddingLeft: 10,
        paddingRight: 10
      }
    };
  }

  render() {
    const styles = this.getStyles(),
      injectStyle = Object.assign(
        {},
        styles.injectStyle,
        !this.context.isLarge && styles.smallInjectStyle
      ),
      { marquee, films, hasUpdatedFilms, location } = this.props,
      { date } = this.state;

    const selectedDate = (date ? moment(date, "YYYY-MM-DD") : moment()).startOf(
      "day"
    );

    return (
      <div>
        <Helmet title={util.capitalize(this.context.tenant.display_schedule)} />
        {this.props.children
          ? React.cloneElement(this.props.children, {
              appSettings: this.props.appSettings
            })
          : undefined}{" "}
        {/* For quick order overlay */}
        <ModeSwitcher value="marquee" />
        {(!this.context.isEmbed ||
          this.props.location.query.showCustomContent) &&
        this.context.tenant.schedule_custom.__html ? ( // Custom HTML is hidden when embedded
          <InjectedTenantHTML
            style={injectStyle}
            content={this.context.tenant.schedule_custom}
          />
        ) : null}
        <MarqueeList
          showLoadingIndicator={
            !marquee || !hasUpdatedFilms || PassStore.isFetchingFirstTime()
          }
          events={marquee && marquee.standaloneEvents}
          films={films}
          showsByDay={marquee && marquee.showsByDay}
          selectedDate={selectedDate}
          onChangeDate={this.onChangeDate}
          onSelectEvent={this.onSelectEvent}
          isYearRound={this.props.appSettings.class === "yearround"}
        />
      </div>
    );
  }
}

export default Radium(Marquee);



// WEBPACK FOOTER //
// ./src/app/components/marquee.jsx